// extracted by mini-css-extract-plugin
export var createdDate = "_m4-1";
export var divider = "_m4-2";
export var headerDivider = "_m4-3";
export var messagesCard = "_m4-0";
export var messagesContainer = "_m4-7";
export var messagesContainerWrapper = "_m4-4";
export var pointerCapturingButtonBoxes = "_m4-a";
export var showLeftPanelButton = "_m4-9";
export var showMoreButton = "_m4-c";
export var showMoreButtonContainer = "_m4-b";
export var summaryTitle = "_m4-6";
export var systemMessageCardWrapper = "_m4-d";
export var topButtons = "_m4-8";
export var withPadding = "_m4-5";